import $ from 'jquery';
import 'foundation-sites';
import 'foundation-sites/js/foundation.responsiveAccordionTabs';
import 'slick-carousel';
import gsap from 'gsap';
import '../styles/app.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import imagePath from '@images/spinner.gif';
import HeroSlider from './components/sliders';
import TestimonialSlider from './components/testimonial';
import fullWidthVideo from './components/full-width-video';
import nafPeople from './components/naf-people';
import personModal from './components/person-modal';
import navigation from './components/navigation';

window.$ = window.jQuery = $;

$(document).ready(function () {
  $(document).foundation();

  $('[data-responsive-accordion-tabs]').each(function () {
    console.log('present')
    if (!this.__foundation__?.ResponsiveAccordionTabs) {
      new Foundation.ResponsiveAccordionTabs(this);
    }
  });


  function initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        once: true,
        offset: 160,
        duration: 400,
        easing: 'ease-out-sine',
      });
    }
  }

  $('.col-head').on('click', function() {
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });

  HeroSlider();
  TestimonialSlider();
  fullWidthVideo();
  nafPeople();
  personModal();
  navigation();
  initAOS();

  setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refreshHard();
    }
  }, 500);

  // Foundation reveal modal video cleanup
  $(document).on('closed.zf.reveal', '[data-reveal]', function () {
    const $modal = $(this);

    // Stop Vimeo using Player API
    $modal.find('iframe[src*="vimeo.com"]').each(function () {
      const player = new Vimeo.Player(this);
      player.pause().catch(function (error) {
        console.error('Vimeo pause error:', error);
      });
    });

    // Stop YouTube (reset src)
    $modal.find('iframe[src*="youtube.com"]').each(function () {
      const $iframe = $(this);
      const src = $iframe.attr('src');
      $iframe.attr('src', '');
      $iframe.attr('src', src);
    });

    // Stop native HTML5 videos
    $modal.find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });
  });

  // Google Maps

  // Google Maps
    function initMap($el) {
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.error('Google Maps not loaded');
        return;
      }

      var $markers = $el.find('.marker');
      var mapArgs = {
        zoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: new google.maps.LatLng($markers.first().data('lat'), $markers.first().data('lng')),
      };

      var map = new google.maps.Map($el[0], mapArgs);
      map.markers = [];

      $markers.each(function () {
        addMarker($(this), map);
      });

      centerMap(map);
    }

    function addMarker($marker, map) {
      var lat = parseFloat($marker.data('lat'));
      var lng = parseFloat($marker.data('lng'));
      var latLng = { lat: lat, lng: lng };

      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
      });

      map.markers.push(marker);

      if ($marker.html()) {
        var infowindow = new google.maps.InfoWindow({
          content: $marker.html(),
        });

        marker.addListener('click', function () {
          infowindow.open(map, marker);
        });
      }
    }

    function centerMap(map) {
      var bounds = new google.maps.LatLngBounds();

      $.each(map.markers, function (i, marker) {
        bounds.extend(marker.getPosition());
      });

      if (map.markers.length === 1) {
        map.setCenter(bounds.getCenter());
      } else {
        map.fitBounds(bounds);
      }
    }

    $(document).ready(function () {
      $('.event-map').each(function () {
        initMap($(this));
      });
    });
});
